import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children, role }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    // Redirect to login with return path
    const redirectTo = encodeURIComponent(location.pathname);
    return <Navigate to={`/login?redirect=${redirectTo}`} replace />;
  }

  // Check role access
  if (role) {
    // Allow "user" role to access user-specific routes
    // Allow "client" role to access client routes (legacy support)
    // Allow "admin" role to access admin routes
    if (user.role !== role) {
      // Redirect based on user's actual role
      if (user.role === "admin") {
        return <Navigate to="/admin" replace />;
      } else if (user.role === "user") {
        return <Navigate to="/portal" replace />;
      } else if (user.role === "client") {
        return <Navigate to="/client" replace />;
      }
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
